const BASE_URI = "https://api.multitool.xyz";
const USER_ID_HEADER = "user";
export async function fetchAPI(path, { user, env }, init) {
    try {
        return await fetch(`${BASE_URI}/${env}${path}`, {
            ...init,
            headers: {
                [USER_ID_HEADER]: user,
                ...init?.headers,
            },
        });
    }
    catch (error) {
        console.error("Error in api request:", error);
        throw error;
    }
}
//# sourceMappingURL=API.js.map